import { BodyText, Tooltip } from '@block-explorer/ui';
import { FlexColumn, FlexRow } from '@make-software/cspr-ui';
import React from 'react';
import { SHORTENED_ENTRY_TYPE_LENGTH, truncateName } from '../utils';
import { buildRouterPath } from '../../../router/utils';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { AccountInfoIcon } from '../../account-info-icon/account-info-icon';
import { Deploy, getAccountInfoLogo } from '@block-explorer/entities';
import { ContractIdentifier } from '../../contract-identifier/contract-identifier';

export const DefaultActionMessage = ({
  deploy,
  hideContractIdentifier = false,
  isHome = false,
}: {
  deploy: Deploy;
  hideContractIdentifier?: boolean;
  isHome?: boolean;
}) => {
  const contractEntryPointName = deploy.entryPoint?.name || '';
  const callerPublicKey = deploy.callerPublicKey || deploy.callerHash;
  const logo = getAccountInfoLogo(deploy.accountInfo);

  return (
    <FlexColumn>
      <FlexRow align={'baseline'} itemsSpacing={4}>
        <FlexRow itemsSpacing={6} align={'baseline'}>
          <Tooltip title={contractEntryPointName}>
            <BodyText monotype size={3} wordBreak noWrap>
              {truncateName(
                contractEntryPointName,
                SHORTENED_ENTRY_TYPE_LENGTH
              )}
            </BodyText>
          </Tooltip>
        </FlexRow>
        {isHome && (
          <FlexRow itemsSpacing={6} align={'center'}>
            <BodyText size={3} variation={'darkGray'}>
              by
            </BodyText>
            <AccountInfoIcon
              publicKey={callerPublicKey}
              logo={logo}
              path={buildRouterPath(
                ACCOUNT_DETAILS_PATH,
                { id: callerPublicKey },
                undefined
              )}
              csprName={deploy.callerCsprName}
            />
          </FlexRow>
        )}
      </FlexRow>
      {!hideContractIdentifier && (
        <FlexRow itemsSpacing={4}>
          <BodyText variation={'darkGray'} size={3}>
            with
          </BodyText>
          <ContractIdentifier
            hash={deploy.contractPackage.contract_package_hash}
            contractPackage={deploy.contractPackage}
          />
        </FlexRow>
      )}
    </FlexColumn>
  );
};
